import { render, staticRenderFns } from "./pic.vue?vue&type=template&id=0e32fcb6&scoped=true&"
import script from "./pic.vue?vue&type=script&lang=js&"
export * from "./pic.vue?vue&type=script&lang=js&"
import style0 from "./pic.vue?vue&type=style&index=0&id=0e32fcb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e32fcb6",
  null
  
)

export default component.exports